import { Component } from '@angular/core';
import { EventsService } from '../events.service';
import { Events } from '../events';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsComponent {
  constructor(public eventsService: EventsService) { }

  allEvents = this.eventsService.allEvents$

  addEvent() {
    this.eventsService.keepFocus = true
    this.eventsService.selectedEvent = undefined
    this.eventsService.addingNewEvent = true
  }

  selectEvent(event: Events) {
    this.eventsService.addingNewEvent = false
    this.eventsService.selectedEvent = event
  }
}
